export default __webpack_public_path__ + "static/media/news2402298.6770cb99.jpg";